import { render, staticRenderFns } from "./pr_travel_history.vue?vue&type=template&id=58f75be5&"
import script from "./pr_travel_history.vue?vue&type=script&lang=js&"
export * from "./pr_travel_history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports